var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"season-part"},[_vm._v("\n  监测季报\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }